"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTime = exports.getDate = void 0;
const getDate = date => new Date(date * 1000).toISOString().split('T')[0];
exports.getDate = getDate;
const getTime = date => new Date(date * 1000).toISOString().split('T')[1].substring(0, 5);
exports.getTime = getTime;